var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16824 2.3791C8.45395 1.60697 9.54603 1.60697 9.83174 2.3791L11.2538 6.2222C11.3436 6.46495 11.535 6.65635 11.7778 6.74618L15.6209 8.16825C16.393 8.45396 16.393 9.54604 15.6209 9.83175L11.7778 11.2538C11.535 11.3437 11.3436 11.5351 11.2538 11.7778L9.83174 15.6209C9.54603 16.393 8.45395 16.393 8.16824 15.6209L6.74616 11.7778C6.65633 11.5351 6.46494 11.3437 6.22218 11.2538L2.37908 9.83175C1.60696 9.54604 1.60696 8.45396 2.37908 8.16825L6.22218 6.74618C6.46494 6.65635 6.65633 6.46495 6.74616 6.2222L8.16824 2.3791Z",
    fill: "#FBBB00",
    fillOpacity: 0.24,
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/star.3319c39cedb8dc6182aafe29d8a40c2f.svg";